import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import chatAPI from "../api/chatApi";
import { RecentChatList } from "../../types/chat";

interface ChatState {
  allWorkgroupChatList?: RecentChatList[];
}

// # initial state
const initialState: ChatState = { allWorkgroupChatList: undefined };

export const trunkChatUrl = createAsyncThunk(
  "chat/chatUrl",
  async (workgroupId: string) => {
    return await chatAPI.chatUrl(workgroupId);
  }
);

export const trunkChatRecent = createAsyncThunk(
  "chat/recent",
  async (workgroupId: string) => {
    return await chatAPI.chatRecent(workgroupId);
  }
);
export const trunkChatRecentAllWorkgroup = createAsyncThunk(
  "chat/recent/list",
  async (size?: number) => {
    return await chatAPI.chatRecentAllWorkgroup(size);
  }
);

export const trunkGetAccessToken = createAsyncThunk(
  "chat/getAccessToken",
  async () => {
    return await chatAPI.getAccessToken();
  }
);

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkChatRecentAllWorkgroup.fulfilled,
      (state, { payload: resp }) => {
        state.allWorkgroupChatList = resp;
      }
    );
  },
});
export const chatActions = chatSlice.actions;

export default chatSlice.reducer;
